import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** PATCH `/srm/misc-purchase-order/{id}/remark`。任意狀態。 */
export async function updateMiscPurchaseOrderRemark(id, payload) {
  const { data: raw } = await request.patch(
    `/srm/misc-purchase-order/${id}/remark`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
